import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../services/api';
import { toast } from 'react-hot-toast';
import { User, Lock, Mail } from 'lucide-react';
import './LoginGarcom.css';

const LoginGarcom = () => {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  // Se já estiver logado e for garçom, redirecionar
  useEffect(() => {
    if (user) {
      if (user.tipo === 'garcom' || user.tipo === 'admin' || user.tipo === 'estabelecimento') {
        navigate('/garcom', { replace: true });
      }
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await login(email, senha);
      console.log('🔐 Resposta do login:', response);
      
      // Verificar se o login foi bem-sucedido
      if (response && response.success && response.user) {
        console.log('✅ Login bem-sucedido. Tipo do usuário:', response.user.tipo);
        
        // Verificar se o usuário é garcom ou admin/estabelecimento
        if (response.user.tipo === 'garcom' || response.user.tipo === 'admin' || response.user.tipo === 'estabelecimento') {
          toast.success('Login realizado com sucesso!');
          console.log('🚀 Redirecionando para /garcom...');
          // Aguardar um pouco para o toast aparecer e então redirecionar
          setTimeout(() => {
            navigate('/garcom', { replace: true });
          }, 300);
        } else {
          // Usuário não é garçom - limpar token sem redirecionar
          console.log('❌ Usuário não é garçom. Tipo:', response.user.tipo);
          localStorage.removeItem('token');
          delete api.defaults.headers.common['Authorization'];
          toast.error('Acesso negado. Este login é apenas para garçons.');
        }
      } else {
        // Login falhou
        console.log('❌ Login falhou:', response);
        const errorMsg = response?.error || 'Credenciais inválidas';
        toast.error(errorMsg);
      }
    } catch (error) {
      console.error('❌ Erro no login:', error);
      const errorMsg = error.response?.data?.message || 'Erro ao fazer login';
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-garcom-container">
      <div className="login-garcom-card">
        <div className="login-garcom-header">
          <div className="logo-garcom">
            <User size={48} />
          </div>
          <h1>Garçom - Sistema de Comandas</h1>
          <p>Cantinho do Sabor</p>
        </div>

        <form onSubmit={handleSubmit} className="login-garcom-form">
          <div className="input-group-garcom">
            <Mail size={20} />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="input-group-garcom">
            <Lock size={20} />
            <input
              type="password"
              placeholder="Senha"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn-garcom-primary" disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <div className="login-garcom-footer">
          <p>Acesso restrito para garçons</p>
        </div>
      </div>
    </div>
  );
};

export default LoginGarcom;

